var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tabs",
    _vm._g(
      _vm._b(
        { staticClass: "pub-tab-card" },
        "el-tabs",
        Object.assign({}, _vm.$attrs),
        false
      ),
      _vm.$listeners
    ),
    [
      _vm._l(_vm.tabsArr, function(tab) {
        return [
          (tab.permission
          ? _vm.checkPermission(tab.permission)
          : [])
            ? _c(
                "el-tab-pane",
                _vm._g(
                  _vm._b(
                    {
                      key: tab.name,
                      attrs: { label: tab.label, name: tab.name }
                    },
                    "el-tab-pane",
                    Object.assign({}, _vm.$attrs),
                    false
                  ),
                  _vm.$listeners
                ),
                [_vm._t(tab.name)],
                2
              )
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }